import React, { Component } from 'react';
import Isvg from 'react-inlinesvg';
import { Container, Row, Col, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import ProfileIcon from '../assets/profile.svg'
import ArrowDownIcon from '../assets/arrow-down.svg'
import SettingsIcon from '../assets/settings.svg'
import SearchIcon from '../assets/search.svg'

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {


        return (
            <header className="header">
                <Container fluid style={{ padding: 0 }}>
                    <Row>
                        <Col lg="10">
                        </Col>
                        <Col lg="2" className="profile-container">
                            <div className="profile">
                                <div className="profile-icon">
                                    <Isvg src={ProfileIcon} />
                                </div>
                                <h6>{this.props.uData && this.props.uData.username}</h6>
                                <div className="profile-settings">
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </header>
        )
    }
}

export default Header;
